import React from "react";
import { CompanyListContainer } from "./styles";
import { ICompany } from "../../../../../../types/companies";
import CompaniesListItem from "../CompaniesListItem/Index";

export type UpdateCompanyBody = {
  isActivated: boolean
}

interface ICompaniesListProps {
  companies: ICompany[];
  handleUpdateCompany: (company: ICompany) => void;
  handleUpdateCompanyStatus: (id: string, data: UpdateCompanyBody) => Promise<void>;
}

const CompaniesList = ({
  companies,
  handleUpdateCompany,
  handleUpdateCompanyStatus,
 
}: ICompaniesListProps) => {
  return (
    <CompanyListContainer>
      {companies.map((company) => (
        <CompaniesListItem
          key={company.id}
          company={company}
          handleUpdateCompany={handleUpdateCompany}
          handleUpdateCompanyStatus={handleUpdateCompanyStatus}
        />
      ))}
    </CompanyListContainer>
  );
};

export default CompaniesList;
